import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { StatusRequirementComponent } from './status-requirement.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [StatusRequirementComponent],
  imports: [CommonModule, MatProgressBarModule, MatStepperModule],
  exports: [StatusRequirementComponent],
})
export class StatusRequirementModule {}
